// User levels as per backend
export enum UserLevel {
  MATERNITY = 1,
  HOSPITAL = 2,
  ADMINISTRATOR = 3,
}

// User level object from backend
export interface UserLevelData {
  id: number;
  level_code: string;
  level_name: string;
  level_order: number;
}

// User interface
export interface User {
  id: number;
  username: string;
  email: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  user_level: UserLevelData;
  user_level_id: number;
  hospital_id: number | null;
  hospital_name?: string;
  assigned_section?: 'chd' | 'prematuri' | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// Login credentials
export interface LoginCredentials {
  username: string;
  password: string;
  remember_me?: boolean;
}

// Login response
export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  user: User;
}

// Token refresh request
export interface RefreshTokenRequest {
  refresh_token: string;
}

// Change password request
export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

// Auth context type
export interface AuthContextType {
  utilizator: User | null;
  loading: boolean;
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => void;
  refreshToken: () => Promise<void>;
  arePermisiune: (permisiune: string) => boolean;
  nivelUtilizator: UserLevel | null;
  isAuthenticated: boolean;
}